export default __webpack_public_path__ + "static/media/CodingQuiz.dc1b1bad.png";